import { visitData } from "dto/his/visitData";
import dxInterceptionApi from "services/dxInterception.api";
import { clinicDTO } from "dto/his/clinicDTO";
import { doctorDTO } from "dto/his/doctorDTO";

const hisService = {
    getVisitData: (hn: string, txn: string, service?: string) => {
        return dxInterceptionApi.get<visitData>(`/his/visits/${hn}/${txn}`, {
            params: {
                service
            }
        });
    },

    getClinic: () => {
        return dxInterceptionApi.get<clinicDTO[]>(`/his/clinics`);
    },

    getDoctor: () => {
        return dxInterceptionApi.get<doctorDTO[]>(`/his/doctors`);
    },
    getRecorder: (id: string) => {
        return dxInterceptionApi.get<{
            name: string;
        }>(`/his/recorder/${id}`);
    }
};

export default hisService;
